import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import {
	GlobalStyle,
	ThemeName,
	ThemeProvider as ThemeProviderAccolade,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { AppRoot, ErrorBoundary } from '@bcp-channels-sharedcomponents-reactjs/core';
import { LoggerHelper, TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { Company, Language, Platform } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { ThemeProvider } from '@bcp-channels-sharedcomponents-reactjs/theme/dist/providers';
import { saveSessionStorage } from '@helpers';
import { DebugSettings, GlobalLoader, UnexpectedError } from '@components';
import { ApiConfig, LoggerConfig } from '@configs';
import { defaultI18n } from '@i18n';
import packageJson from '../package.json';
import { TouchpointFrameworkBootstrap } from './touchpointFrameworkBootstrap';
import './index.css';
import { Anything } from './types/common';
import { FetchToken } from './fetchToken';

let started = false;

export const startSimulator = (targetElement = document.getElementById('root')): void => {
	started = true;

	LoggerHelper.init(LoggerConfig, { all: true, flow: true, core: true, sessionInfo: true });

	TranslationHelper.register(
		'resources.global',
		{
			en: { ab: defaultI18n.en, bcp: defaultI18n.en },
			pt: { ab: defaultI18n.pt, bcp: defaultI18n.pt },
		},
		{ addAndReplace: true }
	);

	// cSpell: disable
	// eslint-disable-next-line
	// GtmHelper.init({ item_category: 'iziBizi', item_type: 'iziBizi' });
	// cSpell: enable

	ReactDOM.render(
		<React.StrictMode>
			<AppRoot
				globalData={{
					company: Company.bcp,
					language: Language.pt,
					platform: Platform.mobile,
				}}
			>
				<ThemeProviderAccolade themeName={ThemeName.BCP}>
					<GlobalStyle />
					<ThemeProvider>
						<DebugSettings>
							<GlobalLoader />
							<ErrorBoundary
								containerErrorMessage={(error: Anything): React.ReactNode => (
									<UnexpectedError error={error} />
								)}
							>
								<Router>
									<FetchToken>
										<TouchpointFrameworkBootstrap />
									</FetchToken>
								</Router>
							</ErrorBoundary>
						</DebugSettings>
					</ThemeProvider>
				</ThemeProviderAccolade>
			</AppRoot>
		</React.StrictMode>,
		targetElement
	);
};

const url = new URL(window.location.href);

const ott = url.searchParams.get('ott');
const tokenOAuth = url.searchParams.get('tokenOAuth');
const state = url.searchParams.get('state');
const plan = url.searchParams.get('plan');
const processId = url.searchParams.get('pid');

// const savedTokenOAuth = getSessionStorage<string>('tokenOAuth');

// cSpell: enable
// if (tokenOAuth || savedTokenOAuth) {
ott && saveSessionStorage('ott', ott);
tokenOAuth && saveSessionStorage('tokenOAuth', tokenOAuth);
state && saveSessionStorage('state', decodeURIComponent(state));
plan && saveSessionStorage('plan', plan);
processId && saveSessionStorage('processId', processId);

if (window.location.pathname === '/') {
	window.history.replaceState(undefined, '', window.location.origin);
}

// cSpell: disable
// const sessionInfo: BaseStateSessionInfo = {
// 	accountList: [],
// 	alias: '',
// 	appMobile: false,
// company: BaseStateSessionInfoCompany.BCP,
// 	flow: BaseStateSessionInfoFlow.Home,
// 	geoId: BaseStateSessionInfoGeoId.Lisbon,
// 	interactionId: '',
// 	language: 'PT',
// 	mobileSystem: '',
// 	ocpApimSubscriptionKey: '536285b3e29b4bcf9702f6e74fb572e8',
// 	sessionId: '',
// 	targetInfrastructure: '21',
// 	targetSystem: 'PTCorporate',
// 	tokenOAuth: tokenOAuth || savedTokenOAuth || '',
// };

startSimulator();
// }

(window as Anything).startSimulator = startSimulator;

(window as Anything).startJourney = startSimulator;

(window as Anything).reactApp = {
	version: packageJson.version,
	config: {
		api: ApiConfig,
		logger: LoggerConfig,
	},
};
